import styled, { css } from 'styled-components'

import { size, fontWeight, fontSize, color } from 'ui/themes/utils'

import Icon from 'ui/blocks/Icon'
import P from 'ui/elements/P'

export const TimeTable = styled.div`
  width: ${({ width }) => width ? `${width}px` : 'auto'};

  ${P} {
    font-size: ${fontSize('md')};
  }
`

export const ScrollContainer = styled.div`
  height: 360px;

  overflow-y: auto;

  @media screen and (max-width: 425px) {
    height: 70vh;
  }
`

export const Header = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  padding: ${size('padding', 'sm')} !important;

  border-bottom: ${size('borderWidth')} solid ${color('Misc/Divider')} !important;

  & > ${Icon} {
    flex: 0;

    cursor: pointer;
  }

  & > ${P} {
    font-weight: ${fontWeight('lighter')};
  }

  & > ${P}:last-of-type {
    flex: 1;

    text-align: center;

    margin: 0;
  }
`

export const Item = styled.div`
  display: flex;
  align-items: center;

  padding: ${size('padding', 'sm')} !important;

  ${({ active }) => active && css`
    background: ${color('Primary/Background2')};
  `}

  ${({ inOpeningHours }) => !inOpeningHours && css`
    opacity: 0.5;
  `}

  & > ${P} {
    margin: 0;

    font-weight: ${fontWeight('lighter')};
  }

  & > ${P}:first-of-type {
    flex: 1;
  }

  & > ${P}:last-of-type {
    text-align: right;
  }
`

export const Indicator = styled.div`
  width: 16px;
  height: 16px;

  margin-right: ${size('margin', 'xs')} !important;

  border-radius: ${size('borderRadius')};

  ${({ status }) => {
    let background

    if (status) {
      switch (status) {
        case 'available':
          background = color('Success/Outline')
          break
        case 'unavailable':
          background = color('Danger/Base')
          break
      }

      return css`
        background-color: ${background};
      `
    } else {
      /* Loading state */
      return css`
        background: #000000;
        opacity: 0.15;

        animation: pulse 1.5s infinite ease-in-out;

        @keyframes pulse {
          0% { opacity: 0.05; }
          50% { opacity: 0.15; }
          100% { opacity: 0.05; }
        }
      `
    }
  }}
`
